var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.iconImg
    ? _c("div", { staticClass: "icon-site" }, [
        _vm.isLazy
          ? _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.getSrc(_vm.iconImg),
                  expression: "getSrc(iconImg)",
                },
              ],
              staticClass: "icon-site-img",
              attrs: { onerror: "this.style.display='none'" },
            })
          : _c("img", {
              staticClass: "icon-site-img",
              attrs: {
                src: _vm.getSrc(_vm.iconImg),
                onerror: "this.style.display='none'",
              },
            }),
        _vm._v(" "),
        _vm.iconType
          ? _c("i", {
              staticClass: "icon-site-type",
              class: "icon-" + _vm.iconType,
            })
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }